import { NavLink, Outlet } from "react-router-dom";
import { ReactComponent as WisdomSvg } from "shared/assets/WisdomLogo.svg";
import { t } from "i18next";
import { useEffect } from "react";
import { useModalContext } from "shared/core/state/ModalContext/ModalContext";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";

export const LoginInfoLayout = () => {
  const { show } = useModalContext("localeModal");

  useEffect(() => {
    show();
  }, [show]);

  return (
    <div className="flex flex-col min-h-screen gap-6 overflow-clip">
      <header role="banner" className="flex flex-row bg-white h-20 w-full sticky top-0 z-OVERLAY drop-shadow-md md:px-[4rem]">
        <NavLink
          className="flex items-center flex-grow w-4/6 h-full pl-6 pr-3 lg:flex-grow-0 xs:pointer-events-none lg:pointer-events-auto sm:w-auto"
          aria-label={t("navigation.homeNavigationLabel")}
          to={"/"}
        >
          <WisdomSvg />
        </NavLink>
      </header>
      <main role="main">
        <Container>
          <Outlet />
        </Container>
      </main>
    </div>
  );
};
